import { CoreIcon } from '../core-icon';
import deleteSVG from '../../assets/icons/delete.svg';
import type { IconProps } from '../core-icon';

export const DeleteIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={deleteSVG} {...props} />;
};
